import {computed} from "vue";

export function useFilterByPaymentMethods(itemsRef, paymentMethodsRef, field = "paymentMethod") {
  const filteredByPaymentMethod = computed(() => {
    let paymentMethods = [...(paymentMethodsRef.value || [])]; // کپی محلی بسازیم

    if (!paymentMethods.length) return itemsRef.value;

    return itemsRef.value.filter((item) =>
      paymentMethods.includes(item[field])
    );
  });

  return {filteredByPaymentMethod};
}
